<!-- ワンタイムコード入力して、認証成功 -->
<template>
  <ItemDialog ref="OnetimeCodeComplete" imageType="done">
    <template v-slot:content-area>
      <h2>
        {{ $t("MyTicketTicketing.QRSuccess.title") }}
      </h2>
    </template>
    <template v-slot:button-area>
      <ItemButton
        :label="$t('MyTicketTicketing.ticketDetails')"
        actionType="btn-primary"
        @clicked="returnNativeAppMyticketPage"
      />
    </template>
  </ItemDialog>
</template>

<script>
export default {
  name: "DialogOnetimeCodeComplete",
  methods: {
    async openDialog() {
      this.$refs.OnetimeCodeComplete.open();
    },
    async closeDialog() {
      this.$refs.OnetimeCodeComplete.close();
    },
  },
};
</script>
